/*
 *
 * ActionPlans reducer
 *
 */

import { fromJS } from "immutable"
import {
  FILTERS_FAILED,
  FILTERS_SUCCESS,
  FILTERS_WATCHER,
  GET_PLANS_FAILED,
  GET_PLANS_SUCCESS,
  GET_PLANS_WATCHER,
  GET_TEMPLATE_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  GET_SURVEYS_WATCHER,
  GET_SURVEYS_SUCCESS,
  GET_SURVEYS_FAILED,
} from "./constants"

export const initialState = fromJS({
  loadingFilters: false,
  filters: {
    measures: [],
    dimensions: [],
    division: [],
    status: [],
    order: [],
  },
  count_action_plans: 0,
  loadingPlans: false,
  plans: [],
  sidebar_divisions: [],
  sidebar_ambassadors: [],
  isDownloading: false,
  resume: [],
  surveys: [],
})

function actionPlansReducer(state = initialState, action) {
  switch (action.type) {
    case FILTERS_WATCHER:
      return state.set("loadingFilters", true)
    case FILTERS_SUCCESS:
      return state.set("loadingFilters", false).set("filters", action.payload)
    case FILTERS_FAILED:
      return state.set("loadingFilters", false).set("filters", [])

    case GET_PLANS_WATCHER:
      return state
        .set("loadingPlans", true)
        .set("sidebar_ambassadors", [])
        .set("sidebar_divisions", [])
        .set("resume", [])
    case GET_PLANS_SUCCESS:
      return state
        .set("loadingPlans", false)
        .set("plans", action.payload.plans)
        .set("count_action_plans", action.payload.count_action_plans)
        .set("sidebar_ambassadors", action.payload.sidebar_ambassadors)
        .set("sidebar_divisions", action.payload.sidebar_divisions)
        .set("resume", action.payload.resume)
    case GET_PLANS_FAILED:
      return state
        .set("loadingPlans", false)
        .set("plans", [])
        .set("count_action_plans", 0)
        .set("sidebar_ambassadors", [])
        .set("sidebar_divisions", [])
        .set("resume", [])
    case GET_TEMPLATE_WATCHER:
      return state.set("isDownloading", true)
    case GET_TEMPLATE_SUCCESS:
      return state.set("isDownloading", false)
    case GET_TEMPLATE_FAILED:
      return state.set("isDownloading", false)
    case GET_SURVEYS_WATCHER:
      return state.set("surveys", [])
    case GET_SURVEYS_SUCCESS:
      return state.set("surveys", action.payload)
    case GET_SURVEYS_FAILED:
      return state.set("surveys", [])
    default:
      return state
  }
}

export default actionPlansReducer
